import CrossIcon from 'src/assets/images/Cross-icon.svg';

type SearchResultItemProps = {
  icon?: any;
  iconAlt?: string;
  iconClassName?: string;
  text: string;
  onClick?: any;
  id?: string;
};

const SearchResultItem = ({
  icon = CrossIcon,
  iconAlt = 'cross icon',
  iconClassName,
  text,
  onClick,
  id,
}: SearchResultItemProps) => {
  return (
    <div className="min-w-[77px] h-7 bg-[#97A0AF] bg-opacity-10 flex items-center justify-center px-2 rounded-md">
      <img
        src={icon}
        alt={iconAlt}
        className={`h-2 w-2 mr-[6px] cursor-pointer ${iconClassName}`}
        onClick={() => onClick(id)}
      />
      <p className="text-blue-950 text-sm font-medium font-SFProDisplay capitalize">
        {text}
      </p>
    </div>
  );
};

export default SearchResultItem;
